module.exports = __webpack_public_path__ + "static/media/difuzaWebLogo.2dcc7030.png";